// extracted by mini-css-extract-plugin
module.exports = {"parent":"desktop-backbutton-module--parent--3aZuT","image":"desktop-backbutton-module--image--117X6","text":"desktop-backbutton-module--text--ye4ga"};